import { useEffect, useMemo } from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Card, InlineNotification } from '../../../../components';
import { AuthErrorResponseCode, AuthErrorResponseCodeToDescriptionMap } from '../../../../common/types/auth-error-response';
import styles from './ForbiddenCountryError.module.css';

export const ForbiddenCountryError = () => {
    const { t } = useTranslation();
    const errorMessage = t('form.socketError.FORBIDDEN_ID_COUNTRY.text');

    useEffect(() => {
        const sr = document.querySelector('output.screenreader-text');
        if (sr) sr.innerHTML = errorMessage;
    }, [errorMessage]);

    const redirectHref = useMemo(() => {
        const qs = new URLSearchParams(window.location.search);
        const ru = qs.get('redirect_uri');
        const state = qs.get('state') ?? '';

        if (!ru) return '/login/';

        const url = new URL(ru);
        url.searchParams.set('state', state);
        url.searchParams.set('error', AuthErrorResponseCode.FORBIDDEN_ID_COUNTRY);
        url.searchParams.set('error_description', AuthErrorResponseCodeToDescriptionMap[AuthErrorResponseCode.FORBIDDEN_ID_COUNTRY]);
        return url.toString();
    }, []);

    return (
        <div data-testid="forbiddenCountryError">
            <Card>
                <main className={styles.main}>
                    <Stack
                        className={styles.errorContainerInner}
                        direction="column"
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '2rem'
                        }}>
                        <InlineNotification appearance="error">
                            <span>{errorMessage}</span>
                        </InlineNotification>
                        <a
                            href={redirectHref}
                            className={styles.backLink}
                            data-testid="sessionCancelLink"
                        >
                            {t('form.main.backToServiceProvider')}
                        </a>
                    </Stack>
                </main>
            </Card>
        </div>
    );
};